export enum ChatMessageTypeEnum {
  TEXT = "text",
  MIME = "mime",
}
